import { AsyncThunk, createAsyncThunk } from '@reduxjs/toolkit';
import { ThunkAPI } from '../rootReducer';
import { HttpMethods, SERVICES } from '../../services/api';
import { basicApiAsyncThunkCreator } from '../../services/apiAsyncThunkCreator';
import { showErrorMessage, showSuccessMessage } from '../notifications';

export interface IResendEmailApiCredentialsRequest {
  accountId: string;
}

export type IResendEmailApiCredentialsResponse = Record<string, unknown>;

export const resendEmailApiCredentials: AsyncThunk<
  IResendEmailApiCredentialsResponse,
  IResendEmailApiCredentialsRequest,
  ThunkAPI
> = createAsyncThunk(
  'apiCredentials/documentation-email',
  async (data: IResendEmailApiCredentialsRequest, thunk) => {
    try {
      const response = await basicApiAsyncThunkCreator<
        IResendEmailApiCredentialsResponse,
        IResendEmailApiCredentialsRequest
      >({
        endpoint: 'apiCredentials/documentation-email',
        microservice: SERVICES.USERS_SERVICE,
        authenticated: true,
        method: HttpMethods.Post,
        contentType: 'application/json'
      })(data, thunk);
      thunk.dispatch(showSuccessMessage('Email with instructions has been sent.'));
      return response;
    } catch (err) {
      const message = err as string || 'An error occurred sending the request to resend the instructions';
      thunk.dispatch(showErrorMessage(message));
      return thunk.rejectWithValue(err);
    }
  }
);